import { GridColDef } from "@mui/x-data-grid";
import { formatNumber } from "../../../common/utils";
import { MeasurableValueDTO } from "../../../datasources/api-client/data-contracts";

export interface MeasureTypes {
	weight?: MeasurableValueDTO;
	tCo2eTtw?: MeasurableValueDTO;
	tCo3eWtw?: MeasurableValueDTO;
	energyTtw?: MeasurableValueDTO;
	energyWtw?: MeasurableValueDTO;
	distance?: MeasurableValueDTO;
	total?: MeasurableValueDTO;
	electricity?: MeasurableValueDTO;
	fuels?: MeasurableValueDTO;
	refrigerants?: MeasurableValueDTO;
	heatSteam?: MeasurableValueDTO;
	processGas?: MeasurableValueDTO;
	water?: MeasurableValueDTO;
}

export const headerCellMeasure = (
	col: GridColDef | undefined,
	dataSample: MeasureTypes,
	overrideFields?: (old?: string) => string | undefined
): string => {
	const field = !overrideFields
		? (col?.field as keyof MeasureTypes)
		: (overrideFields(col?.field) as keyof MeasureTypes);

	return (dataSample && dataSample[field]?.measure) ?? "";
};

export const safeLabel = (label?: string | null, id?: number | null) =>
	!label || id === null || id === undefined ? "-" : label;

export const formatOptional = (value: any, formatter?: (v: any) => string): string => {
	if (value === null || value === undefined || value === "") return "-";
	return formatter ? formatter(value) : String(value);
};

/** Rreturns value:string + measure:string */
export const formatMVSafe = (mv?: MeasurableValueDTO | null) => {
	if (!mv || mv.value === null || mv.value === undefined) {
		return { value: "-", measure: "" };
	}

	return {
		value: formatNumber(mv.value, "decimal", 2, 2),
		measure: mv.measure ?? "",
	};
};

export interface DisplayItem {
	label: string;
	value: string;
	measure: string;
	reqExpand: boolean;
}

// Normal value
export const item = (label: string, value: any, reqExpand = false, formatter?: (v: any) => string): DisplayItem => ({
	label,
	value: formatOptional(value, formatter),
	measure: "",
	reqExpand,
});

export const itemMV = (label: string, mv?: MeasurableValueDTO | null, reqExpand = true): DisplayItem => ({
	label,
	...formatMVSafe(mv),
	reqExpand,
});
